// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"b2c92297","353":"b1cfda3a","453":"87e45203","561":"28f4ed0d","621":"98389380","697":"e2d83f8a","712":"3de39d02","859":"3cb7d96f"}[chunkId] + ".chunk.js";
};